module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Nome:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "name": "nome"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "nome"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Cor:")]), _c('color-palette', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "cor"
    },
    on: {
      "input": _vm.onCorChange
    },
    model: {
      value: (_vm.cor),
      callback: function($$v) {
        _vm.cor = $$v
      },
      expression: "cor"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "cor"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Vetorização:")]), _c('div', [_c('draw-button', {
    staticClass: "col-md-12",
    attrs: {
      "drawTool": _vm.drawTool
    },
    on: {
      "drawComplete": _vm.onGeometriaVetorizada
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validacaoExecutada && (!this.geometrias || this.geometrias.length === 0)),
      expression: "validacaoExecutada && (!this.geometrias || this.geometrias.length === 0)"
    }],
    staticClass: "invalid-field"
  }, [_vm._v(" É necessário vetorizar ao menos uma geometria.")])], 1)]), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.geometrias && _vm.geometrias.length),
      expression: "geometrias && geometrias.length"
    }],
    staticClass: "list-group"
  }, _vm._l((_vm.geometrias), function(geom, index) {
    return _c('li', {
      staticClass: "list-group-item",
      on: {
        "mouseenter": function($event) {
          _vm.onGeometriaMouseEnter(index)
        },
        "mouseleave": function($event) {
          _vm.onGeometriaMouseLeave(index)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.tipoGeometria.nome + ' ' + (index + 1))), _c('i', {
      staticClass: "action-icon mdi mdi-window-close",
      on: {
        "click": function($event) {
          _vm.removerGeometria(index)
        }
      }
    })])
  })), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  }), _vm._v(" Cancelar")]), _c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adicionarCamada()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-check"
  }), _vm._v(" Adicionar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1848f100","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adicaoCamadas/AdicaoCamadaGeometria.vue
// module id = 469
// module chunks = 1